import { LoanProductType } from "../hooks/api/types";

export const CREDIT_FACILITY_PRODUCT_TYPES: readonly LoanProductType[] = [
  LoanProductType.LOC_INVOICE_DISCOUNTING,
  LoanProductType.LOC_PAYABLE_FINANCING,
  LoanProductType.LOC_RECEIVABLES_NON_RECOURSE,
];

const RECEIVABLES_LOC_PRODUCT_TYPES: readonly LoanProductType[] = [
  LoanProductType.LOC_INVOICE_DISCOUNTING,
  LoanProductType.LOC_RECEIVABLES_NON_RECOURSE,
];

const includesProductType = (
  types: readonly LoanProductType[],
  type?: string | null
): boolean => !!type && (types as readonly string[]).includes(type);

export const isCreditFacility = (type?: string | null): boolean =>
  includesProductType(CREDIT_FACILITY_PRODUCT_TYPES, type);

export const isReceivablesLOC = (type?: string | null): boolean =>
  includesProductType(RECEIVABLES_LOC_PRODUCT_TYPES, type);
